function index() {
  return (
    <main className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center">
      <p className="text-center">
        풍요로운 책세상에서 제공하는 각종 계산기를
        <br />
        한글 프로그램 없이 웹에서 사용할 수 있습니다.
      </p>
    </main>
  );
}

export default index;
